import { cva } from 'class-variance-authority';

export const PaginatedSelectTriggerVariants = cva(
  'flex items-center justify-between w-full min-h-[2.25rem] px-[0.625rem] rounded-[0.5rem] transition-all cursor-pointer',
  {
    variants: {
      size: {
        default: 'h-[2.25rem] text-sm',
        sm: 'h-[2rem] text-xs',
        lg: 'h-[2.75rem] text-base',
      },
      outline: {
        true: 'border border-primary-active-border',
        false: 'border border-outline',
      },
      disabled: {
        true: 'opacity-50 cursor-not-allowed',
        false: '',
      },
    },
    defaultVariants: {
      size: 'default',
      outline: true,
      disabled: false,
    },
  },
);

export const PaginatedSelectContentVariants = cva(
  'relative z-50 w-full rounded-[0.5rem] bg-select-background border border-outline shadow-lg animate-in fade-in-0 zoom-in-95',
);

export const PaginatedSelectInputVariants = cva(
  'flex w-full h-[2.25rem] px-[0.625rem] rounded-[0.5rem] bg-transparent text-sm placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/50',
);

export const PaginatedSelectItemVariants = cva(
  'relative flex items-center w-full px-[0.625rem] py-2 cursor-pointer rounded-[0.25rem] text-sm transition-colors hover:bg-accent',
  {
    variants: {
      selected: {
        true: 'bg-accent',
        false: '',
      },
      disabled: {
        true: 'opacity-50 cursor-not-allowed pointer-events-none',
        false: '',
      },
    },
    defaultVariants: {
      selected: false,
      disabled: false,
    },
  },
);

export const PaginatedSelectLabelVariants = cva('text-sm font-medium text-foreground');

export const PaginatedSelectHelperTextVariants = cva('text-xs text-muted-foreground mt-1');

export const PaginatedSelectErrorTextVariants = cva('text-xs text-destructive mt-1');
